import React, { useState } from 'react'
import { Link } from 'react-router-dom'

import useTitle from '../../hooks/useTitle'

// 17 Jul 2026
// Trinity logo
import EtEtTrinityIcon6SVGComp from '@/assets/img/icons/svgComp/EtEtTrinityIcon6SVGComp'


//const serverUrl = process.env.SERVER_URL || 'http://localhost:4500'
//const serverUrl = 'https://etwebapp1-be.onrender.com'
const serverUrl = process.env.REACT_APP_SERVER_URL


// 0a - Email Icon - 17 Jul 2026
const EmailIcon = ({ isDark }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    className={`absolute left-0 top-1/2 h-5 w-5 -translate-y-1/2 transition group-focus-within:text-orange-500 ${
      isDark
        ? 'text-gray-600'
        : 'text-gray-400'
    }`}
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3.75 6.75A1.75 1.75 0 015.5 5h13A1.75 1.75 0 0120.25 6.75v10.5A1.75 1.75 0 0118.5 19h-13a1.75 1.75 0 01-1.75-1.75V6.75Z"
    />

    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m4.5 6 7.5 6 7.5-6"
    />
  </svg>
)


// 0b - Button Arrow Icon - 17 Jul 2026
const ArrowIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 12h14m-5-5 5 5-5 5"
    />
  </svg>
)


// 0c - Light Theme Icon - 17 Jul 2026
const SunIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    className="h-4 w-4"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="3.5" />

    <path
      strokeLinecap="round"
      d="M12 2.5v2M12 19.5v2M4.5 12h-2M21.5 12h-2M5.3 5.3l1.4 1.4M17.3 17.3l1.4 1.4M18.7 5.3l-1.4 1.4M6.7 17.3l-1.4 1.4"
    />
  </svg>
)


// 0d - Dark Theme Icon - 17 Jul 2026
const MoonIcon = () => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    className="h-4 w-4"
    aria-hidden="true"
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M20.2 15.2A8.2 8.2 0 018.8 3.8 8.7 8.7 0 1020.2 15.2Z"
    />
  </svg>
)


const PasswordReset = () => {
  // Author - Atul Pandey
  // Updated - 17 Jul 2026 - refined visual appeal
  // Updated - 17 Jul 2026 - added light and dark theme toggle
  // Updated - 17 Jul 2026 - expanded email input width
  // Updated - 17 Jul 2026 - simplified to a centered account recovery dialog
  // Updated - 17 Jul 2026 - aligned visual design with Login page

  // 0 - Use Title
  useTitle('Forgot Password')

  // 1a - Password Reset State
  const [
    resetPasswordEmail,
    setResetPasswordEmail,
  ] = useState('')

  const [
    resetPasswordMessage,
    setResetPasswordMessage,
  ] = useState('')

  // 1b - Request State - 17 Jul 2026
  const [isSubmitting, setIsSubmitting] =
    useState(false)

  // 1c - Theme State - 17 Jul 2026
  // Light theme remains the default each time the page opens.
  const [isDark, setIsDark] = useState(false)

  // 2a - Theme Based Class Variables - 17 Jul 2026
  const pageClass = isDark
    ? 'bg-[#0d0d0e] text-white'
    : 'bg-gradient-to-b from-white via-gray-50 to-orange-50/60 text-gray-900'

  const mainTextClass = isDark
    ? 'text-white'
    : 'text-gray-900'

  const mutedTextClass = isDark
    ? 'text-gray-500'
    : 'text-gray-500'

  const secondaryTextClass = isDark
    ? 'text-gray-600'
    : 'text-gray-400'

  const dialogClass = isDark
    ? 'border-white/[0.08] bg-[#141415]/90 shadow-black/40'
    : 'border-gray-200/80 bg-white/90 shadow-gray-300/50'

  const emailInputClass = isDark
    ? 'border-gray-700 text-white placeholder:text-gray-600 hover:border-gray-600 focus:border-orange-500'
    : 'border-gray-300 text-gray-900 placeholder:text-gray-400 hover:border-gray-400 focus:border-orange-500'

  const dividerClass = isDark
    ? 'border-gray-800'
    : 'border-gray-200'

  const themeToggleContainerClass = isDark
    ? 'border-white/10 bg-white/[0.05]'
    : 'border-gray-200 bg-white/75'

  // 3a - Handle Email Input
  const handleEmailInput = (e) => {
    setResetPasswordEmail(e.target.value)
    setResetPasswordMessage('')
  }

  // 3b - Handle Theme Toggle - 17 Jul 2026
  const handleThemeToggle = () =>
    setIsDark((prev) => !prev)

  // 4 - Handle Submit
  const handleSubmit = async (e) => {
    e.preventDefault()

    // Basic validation
    if (!resetPasswordEmail.trim()) {
      setResetPasswordMessage(
        'Please enter your email'
      )

      return
    }

    // Send the email to the server to check and validate
    try {
      setIsSubmitting(true)
      setResetPasswordMessage('')

      const response = await fetch(
        `${serverUrl}/users/forgot-password`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: resetPasswordEmail.trim(),
          }),
        }
      )

      const data = await response.json()

      setResetPasswordMessage(
        data.message ||
        'Please check your email for the password reset link.'
      )
    } catch (error) {
      // Error handling
      console.error('Error:', error)

      setResetPasswordMessage(
        'Unable to process your request. Please try again.'
      )
    } finally {
      setIsSubmitting(false)
    }
  }

  // 5 - Main Page Content
  const content = (
    <main
      className={`relative flex min-h-screen flex-col overflow-hidden font-poppins transition-colors duration-500 ${pageClass}`}
    >
      {/* 5a - Minimal Background Illumination */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 overflow-hidden"
      >
        <div
          className={`absolute -left-52 -top-52 h-[500px] w-[500px] rounded-full blur-[150px] ${
            isDark
              ? 'bg-orange-600/10'
              : 'bg-orange-200/35'
          }`}
        />

        <div
          className={`absolute -bottom-64 right-[-170px] h-[580px] w-[580px] rounded-full blur-[165px] ${
            isDark
              ? 'bg-orange-900/10'
              : 'bg-orange-100/50'
          }`}
        />
      </div>

      {/* 5b - Theme Toggle */}
      <div className="absolute right-4 top-4 z-30 sm:right-7 sm:top-6">
        <button
          type="button"
          onClick={handleThemeToggle}
          aria-label={
            isDark
              ? 'Switch to light theme'
              : 'Switch to dark theme'
          }
          title={
            isDark
              ? 'Switch to light theme'
              : 'Switch to dark theme'
          }
          className={`flex h-9 items-center gap-1 rounded-full border p-1 shadow-sm backdrop-blur-md transition-colors duration-300 ${themeToggleContainerClass}`}
        >
          <span
            className={`flex h-7 w-7 items-center justify-center rounded-full transition-all duration-300 ${
              !isDark
                ? 'bg-orange-500 text-white shadow-sm'
                : 'text-gray-500'
            }`}
          >
            <SunIcon />
          </span>

          <span
            className={`flex h-7 w-7 items-center justify-center rounded-full transition-all duration-300 ${
              isDark
                ? 'bg-orange-500 text-white shadow-sm'
                : 'text-gray-400'
            }`}
          >
            <MoonIcon />
          </span>
        </button>
      </div>

      {/* 6 - Centered Page Layout */}
      <div className="relative z-10 flex flex-1 items-center justify-center px-4 py-6 sm:px-6 sm:py-8">

        {/* 7 - Password Reset Dialog */}
        <section
          className={`w-full max-w-[560px] rounded-[28px] border px-7 py-7 shadow-xl backdrop-blur-xl transition-colors duration-500 sm:px-10 sm:py-8 ${dialogClass}`}
        >
          {/* 7a - Trinity Logo and Account Recovery Message */}
          <div className="flex items-center gap-5 sm:gap-8">

            {/* 7a1 - Trinity Logo */}
            <Link
              to="/login"
              className="shrink-0"
              aria-label="Return to Trinity sign in"
            >
              <div
                className={`flex h-14 w-14 items-center justify-center rounded-full bg-black shadow-lg sm:h-16 sm:w-16 ${
                  isDark
                    ? 'shadow-black/50 ring-1 ring-orange-500/20'
                    : 'shadow-gray-400/50'
                }`}
              >
                <EtEtTrinityIcon6SVGComp className="h-10 w-10 text-orange-500 sm:h-12 sm:w-12" />
              </div>
            </Link>

            {/* 7a2 - Account Recovery Message */}
            <div className="min-w-0 flex-1">
              <p className="text-[9px] font-semibold uppercase tracking-[0.28em] text-orange-600">
                Recover
              </p>

              <h1
                className={`mt-1.5 text-lg font-semibold leading-6 tracking-[-0.025em] sm:text-xl sm:leading-7 ${mainTextClass}`}
              >
                Return to your purpose native journey.
              </h1>

              <p
                className={`mt-2 text-xs leading-5 sm:text-sm ${mutedTextClass}`}
              >
                Enter the email linked to your Trinity account.
              </p>
            </div>
          </div>

          {/* 7b - Header Divider */}
          <div
            className={`my-6 border-t ${dividerClass}`}
          />

          {/* 7c - Password Reset Message */}
          {resetPasswordMessage && (
            <div
              aria-live="polite"
              className={`mb-5 border-l-2 border-orange-500 px-4 py-3 text-sm leading-6 ${
                isDark
                  ? 'bg-orange-500/10 text-orange-200'
                  : 'bg-orange-50 text-orange-800'
              }`}
            >
              {resetPasswordMessage}
            </div>
          )}

          {/* 8 - Password Reset Form */}
          <form
            className="space-y-6"
            onSubmit={handleSubmit}
          >
            {/* 8a - Email Address */}
            <div className="group relative">
              <EmailIcon isDark={isDark} />

              <input
                id="email"
                type="email"
                placeholder="Email address"
                aria-label="Email address"
                value={resetPasswordEmail}
                className={`w-full border-0 border-b bg-transparent py-3 pl-9 pr-4 text-sm outline-none transition focus:ring-0 ${emailInputClass}`}
                onChange={handleEmailInput}
                autoComplete="email"
                required
              />
            </div>

            {/* 8b - Email Guidance */}
            <p
              className={`text-[10px] leading-5 ${secondaryTextClass}`}
            >
              Use the complete email address associated
              with your Trinity account.
            </p>

            {/* 8c - Send Reset Link Button */}
            <button
              type="submit"
              disabled={isSubmitting}
              className="group flex w-full items-center justify-center gap-2 rounded-full bg-gradient-to-r from-orange-700 via-orange-600 to-orange-500 px-5 py-3 text-sm font-semibold text-white shadow-lg shadow-orange-500/20 transition duration-300 hover:-translate-y-0.5 hover:shadow-xl hover:shadow-orange-500/25 focus:outline-none focus:ring-4 focus:ring-orange-300/40 disabled:cursor-not-allowed disabled:opacity-50"
            >
              {isSubmitting
                ? 'Sending reset link...'
                : 'Send reset link'}

              {!isSubmitting && <ArrowIcon />}
            </button>
          </form>

          {/* 9 - Sign In Navigation */}
          <div
            className={`mt-6 border-t pt-5 ${dividerClass}`}
          >
            <div className="flex items-center justify-center gap-2 text-center">
              <p
                className={`text-xs ${mutedTextClass}`}
              >
                Remember your password?
              </p>

              <Link
                to="/login"
                className="text-xs font-medium text-orange-600 transition hover:text-orange-700"
              >
                Back to sign in
              </Link>
            </div>
          </div>

          {/* 10 - Copyright */}
          <div
            className={`mt-5 border-t pt-4 text-center ${dividerClass}`}
          >
            <p
              className={`text-[10px] leading-5 ${secondaryTextClass}`}
            >
              © {new Date().getFullYear()} Eternity Solutions Corp.
              All rights reserved.
            </p>
          </div>
        </section>
      </div>
    </main>
  )

  return content
}

export default PasswordReset